"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeGAME = function CategoryCodeGAME(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeGAME"), _react.default.createElement("path", {
    d: "M7.164,8.413V7.587a.2.2,0,0,0-.209-.207H5.7V6.14a.2.2,0,0,0-.059-.148.2.2,0,0,0-.15-.058H4.656a.2.2,0,0,0-.15.058.2.2,0,0,0-.059.148V7.38H3.193a.2.2,0,0,0-.209.207v.826a.2.2,0,0,0,.209.207H4.447V9.86a.2.2,0,0,0,.059.148.2.2,0,0,0,.15.058h.836a.2.2,0,0,0,.15-.058A.2.2,0,0,0,5.7,9.86V8.62H6.955a.2.2,0,0,0,.209-.207Zm3.762.413a.793.793,0,0,0-.245-.584.843.843,0,0,0-1.182,0,.82.82,0,0,0,0,1.169.843.843,0,0,0,1.182,0A.794.794,0,0,0,10.926,8.826ZM12.6,7.174a.794.794,0,0,0-.245-.585.843.843,0,0,0-1.182,0,.82.82,0,0,0,0,1.169.843.843,0,0,0,1.182,0A.793.793,0,0,0,12.6,7.174ZM14.27,8a3.165,3.165,0,0,1-.98,2.337,3.365,3.365,0,0,1-4.572.142H7.282a3.271,3.271,0,0,1-2.208.827,3.239,3.239,0,0,1-2.364-.969A3.165,3.165,0,0,1,1.73,8a3.165,3.165,0,0,1,.98-2.337,3.239,3.239,0,0,1,2.364-.969h5.852a3.239,3.239,0,0,1,2.364.969A3.165,3.165,0,0,1,14.27,8Z"
  })));
};

var _default = CategoryCodeGAME;
exports.default = _default;